module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-container"
  }, _vm._l((_vm.allProducts), function(p) {
    return _c('div', {
      staticClass: "product"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: p.id
          }
        }
      }
    }, [_vm._v(_vm._s(p.title))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v("$ " + _vm._s(p.price))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-931ffdb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomePage.vue
// module id = 97
// module chunks = 1